<template>
    <div class="tw:relative tw:w-full">
        <input
            type="text"
            :placeholder="' '"
            class="tw:block tw:px-4 tw:py-3 tw:w-full tw:text-sm tw:rounded-xl tw:border tw:border-slate-200 tw:bg-white tw:text-slate-900 tw:outline-none tw:transition tw:peer focus:tw:border-blue-400 focus:tw:ring-2 focus:tw:ring-blue-100 tw:placeholder-slate-300"
            v-bind="$attrs"
        />
        <span
            v-if="label"
            class="tw:absolute tw:uppercase tw:duration-300 tw:z-10 tw:pointer-events-none tw:tracking-wide tw:origin-left tw:bg-white tw:px-2
            tw:start-2 tw:top-3 tw:-translate-y-[1.35rem] tw:scale-75 tw:font-bold tw:text-slate-500
            tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:-translate-y-1/2 tw:peer-placeholder-shown:top-1/2 tw:peer-placeholder-shown:font-normal tw:peer-placeholder-shown:text-slate-400
            tw:peer-focus:top-3 tw:peer-focus:-translate-y-[1.35rem] tw:peer-focus:scale-75 tw:peer-focus:font-bold tw:peer-focus:text-blue-500"
        >
            {{ label }}
        </span>
    </div>
</template>

<script setup>
    defineProps({
        label: { type: String, default: '' }
    });
</script>

<script>
    export default { inheritAttrs: false };
</script>
